import { createMuiTheme } from '@material-ui/core/styles';
import '../styles/common.css'; // Check all possible fields at: https://material-ui.com/customization/default-theme/

export var theme = createMuiTheme({
  typography: {
    // Use the system font instead of the default Roboto font.
    fontFamily: ['Work Sans'].join(','),
    h1: {
      color: '#57637C',
      fontSize: '52px',
      lineHeight: '60px'
    },
    h2: {
      color: '#57637C',
      fontSize: '28px',
      lineHeight: '24px',
      fontWeight: 'bold'
    },
    h3: {
      color: '#57637C',
      fontSize: '24px',
      lineHeight: '24px',
      fontWeight: 'bold'
    },
    h4: {
      color: '#57637C',
      fontSize: '22px',
      lineHeight: '24px',
      fontWeight: 'bold'
    },
    h5: {
      color: '#57637C',
      fontSize: '20px',
      fontWeight: 600,
      lineHeight: '22px'
    },
    h6: {
      color: '#57637C',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '20px'
    },
    body1: {
      fontSize: '14px',
      lineHeight: '14px',
      color: '#333940'
    },
    useNextVariants: true
  },
  palette: {
    primary: {
      main: '#FF8200'
    },
    secondary: {
      main: '#57637C'
    },
    error: {
      main: '#FF2825'
    }
  },
  button: {
    fontSize: '12px'
  }
});